import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/main.css'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

// Configuración global de axios.
// Dev: '/apiecom' → el proxy de vue.config.js lo reescribe a /api en nginx.
// Prod (Cloudflare Pages): no hay proxy, usar la URL absoluta de la API.
// VUE_APP_API_URL debe incluir el sufijo /api (ej: https://api-stg.escality.online/api).
axios.defaults.baseURL = process.env.NODE_ENV === 'development'
  ? '/apiecom'
  : (process.env.VUE_APP_API_URL || '/apiecom')
// Interceptor para enviar X-Referrer con el slug de la empresa
axios.interceptors.request.use(config => {
  // Intentar obtener el slug del router, del path, o del env
  const companySlug = router.currentRoute.params.company
    || window.location.pathname.split('/')[1]
    || process.env.VUE_APP_COMPANY_SLUG
  const origin = window.location.origin
  config.headers['X-Referrer'] = companySlug ? `${origin}/${companySlug}` : origin
  if (companySlug) {
    config.headers['X-Company'] = companySlug
  }
  return config
})

Vue.prototype.$axios = axios

// Sentry / GlitchTip
if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    tracesSampleRate: parseFloat(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE) || 1.0,
    tracePropagationTargets: ['localhost', 'api.escality.local', /^https:\/\/api\.escality\.online/],
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')